// src/routes/statistics/report/utils/csvDownload.js

export const downloadCsvFile = (rows, filename) => {
    try {
      const escapeCell = (cell) => {
        if (cell === null || cell === undefined) return '';
        const s = String(cell);
        const needsQuote = /[",\n\r]/.test(s);
        const escaped = s.replace(/"/g, '""');
        return needsQuote ? `"${escaped}"` : escaped;
      };
  
      const csvString = rows
        .map((row) => row.map(escapeCell).join(','))
        .join('\r\n');
  
      const bom = '\ufeff';
      const blob = new Blob([bom + csvString], {
        type: 'text/csv;charset=utf-8;',
      });
  
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
  
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      window.URL.revokeObjectURL(url);
      return true;
    } catch (e) {
      console.error('[CSV 다운로드] 실패:', e);
      return false;
    }
  };